import { ApiResponse, PaymentMethodPlugin, PaymentMethodUpdate, TableResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";

export const ExtensionApi = apiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            getAllExtensions: builder.query<TableResponse<PaymentMethodPlugin>, { org_id: number, query?: string }>({
                query: ({ org_id, query }) => ({
                    url:`/extensions?org_id=${org_id}${query ? `&${query}` : ''}`,
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                providesTags: ["Extensions"],
            }),
            
            updateExtension: builder.mutation<ApiResponse, PaymentMethodPlugin>({
                query: (payment_method) => ({
                    url: `/extensions/${payment_method.id}`,
                    method: "PUT",
                    body: payment_method,
                    headers: {
                        Accept: "application/json",
                    },
                }),
                invalidatesTags: ["Extensions"],
            }),
        };
    },
});


export const {
    useGetAllExtensionsQuery,
    useUpdateExtensionMutation
} = ExtensionApi
